import makeStyles from 'housecall-ui/dist/DesignSystem/Styles/makeStyles';
import React, { ReactElement } from 'react';
import Typography from 'housecall-ui/dist/DesignSystem/DataDisplay/Typography/Typography';

type Props = {
  name: string;
  icon: ReactElement
}
const useStyles = makeStyles((theme) => ({
  inlineIcon: {
    verticalAlign: 'middle',
    marginRight: theme.spacing(1),
  },
}));

const SectionTitle = (props: Props) => {
  const { icon, name } = props;
  const classes = useStyles();

  const clonedIcon = React.cloneElement(icon, { className: classes.inlineIcon });
  return (
    <Typography variant="subtitle1">
      {clonedIcon}
      {name}
    </Typography>
  );
};

export default SectionTitle;
